module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/ClarkDeco_Bottom-ccf242ffcde26bf41e49bd7638976bde.png";